import { render, staticRenderFns } from "./CostDetail.vue?vue&type=template&id=5f09197c&scoped=true&"
import script from "./cost-detail.js?vue&type=script&lang=js&"
export * from "./cost-detail.js?vue&type=script&lang=js&"
import style0 from "./cost-detail.css?vue&type=style&index=0&id=5f09197c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f09197c",
  null
  
)

export default component.exports